import {
	FETCH_REFERRER_PATIENTS,
	FETCH_REFERRER_PATIENTS_SUCCESS,
	FETCH_REFERRER_PATIENTS_ERROR,
	FETCH_REFERRER_PENDING,
	FETCH_REFERRER_PENDING_SUCCESS,
	FETCH_REFERRER_PENDING_ERROR,
} from './constants';

export const fetchReferrerPatients = (page = 1) => ({
	type: FETCH_REFERRER_PATIENTS,
	page,
});

export const fetchReferrerPatientsSuccess = (data) => ({
	type: FETCH_REFERRER_PATIENTS_SUCCESS,
	data,
});

export const fetchReferrerPatientsError = (error) => ({
	type: FETCH_REFERRER_PATIENTS_ERROR,
	error,
});

export const fetchReferrerPending = () => ({
	type: FETCH_REFERRER_PENDING,
});

export const fetchReferrerPendingSuccess = (data) => ({
	type: FETCH_REFERRER_PENDING_SUCCESS,
	data,
});

export const fetchReferrerPendingError = (error) => ({
	type: FETCH_REFERRER_PENDING_ERROR,
	error,
});
